import React, { FC } from 'react'
import styled from 'styled-components'

import { down } from '@Globals/Style/breakpoints'

interface NavBarButtonProps {
  onCategoryClick: () => void
  onCategoryMouseEnter: () => void
  onCategoryMouseLeave: () => void
  title: string
}

interface WrapperProps {
  afterColor?: string
}

const Wrapper = styled.div<WrapperProps>`
  color: ${({ theme }) => theme.colors.greyDark};
  position: relative;
  text-transform: uppercase;
  padding: 14px 15px 12px;
  cursor: pointer;
  height: 48px;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    margin-left: 0;
    background-color: ${({ afterColor, theme }) => afterColor ?? theme.colors.greyDark};
  }

  &:hover {
    &:after {
      margin-left: -25%;
      width: 50%;
    }
  }

  ${down('maxWidth')} {
    padding: 15px 11px 12px;
    font-size: 0.875rem;
  }
  
  &:first-child {
    padding-left: 0;
  }
`

export const NavBarButton: FC<NavBarButtonProps> = ({
  onCategoryClick,
  onCategoryMouseEnter,
  onCategoryMouseLeave,
  title,
}: NavBarButtonProps) => (
  <Wrapper
    onClick={() => onCategoryClick()}
    onMouseEnter={() => onCategoryMouseEnter()}
    onMouseLeave={() => onCategoryMouseLeave()}
  >
    {title}
  </Wrapper>
)
